import React, { FC, useRef, useState } from "react";
import { Spin } from "antd";
import cx from "classnames";
import styles from "./throttleButton.module.less";
import { ButtonHTMLType } from "antd/lib/button/button";

const ThrottleButton: FC<{
  className?: string;
  loading?: boolean;
  primary?: boolean;
  unEvent?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  type?: ButtonHTMLType;
  delay?: number;
  disabled?: boolean;
  dataTestid?: string;
  id?: string;
}> = ({
  id,
  className,
  children,
  primary,
  onClick,
  unEvent,
  loading = false,
  type = "button",
  delay = 2000,
  disabled,
  dataTestid,
  ...props
}) => {
  const [isDisable, setDisable] = useState(false);
  const isDisableFlag = useRef(false);
  const ThrottleButtonTimeId = useRef(0);

  const delayFn = (callback: () => void) => {
    if (isDisableFlag.current || disabled) return;

    setDisable(true);
    isDisableFlag.current = true;
    clearTimeout(ThrottleButtonTimeId.current);
    callback();

    ThrottleButtonTimeId.current = window.setTimeout(() => {
      setDisable(false);
      isDisableFlag.current = false;
    }, delay);
  };

  return (
    <button
      {...props}
      id={id}
      data-testid={dataTestid}
      disabled={isDisable || disabled}
      className={className ? className : cx(styles["button"], { [styles["primary"]]: primary })}
      onClick={(e) => {
        e.preventDefault();
        delayFn(() => {
          onClick && onClick(e);
        });
      }}
      type={type}
    >
      {children}
    </button>
  );
};

export default ThrottleButton;
